<app-spinner></app-spinner>

<mat-sidenav-container class="container">
  <mat-sidenav *ngIf="isLoggedIn$ | async as isLoggedIn" #sidenav [mode]="over" [(opened)]="opened"
    class="bottom-to-top sidemenu-back">
    <app-sidemenu></app-sidemenu>
  </mat-sidenav>

  <mat-sidenav-content>
    <app-header *ngIf="isLoggedIn$ | async as isLoggedIn" (sideNav)="getSideNav()">
    </app-header>
    <router-outlet></router-outlet>
    @if (scrollNavigationEnabled) {
      <app-scroll-navigation />
    }
    <!--<div class="bottom-img-wrapper" *ngIf="isLoggedIn$ | async as isLoggedIn">
      <img src="./../assets/img/dark.png" class="bottom-img"/>
    </div>-->
  </mat-sidenav-content>
</mat-sidenav-container>
